import { SwitchFormComponent } from 'commons/components';
import { useTranslation } from 'core/i18n/i18n';
import { SettingsCardLayout } from 'modules/settings/settings.style';
import { ApplicableLocationsConfig } from '../domain';
import {
    TrainingProgramTitle,
    TrainingProgramTrainerBody,
} from './training-programs-applicable-locations-config.style';

interface TrainingProgramsApplicableLocationsConfigProps {
    config: ApplicableLocationsConfig;
    loading: boolean;
    onConfigChange: (config: ApplicableLocationsConfig) => void;
}

export const TrainingProgramsApplicableLocationsConfigComponent: React.FC<
    TrainingProgramsApplicableLocationsConfigProps
> = (props) => {
    const { t } = useTranslation();

    const { config, loading, onConfigChange } = props;

    const handleOnConfigChange = (enableTrainingLocations: boolean) => {
        onConfigChange({
            ...config,
            enableApplicableLocations: enableTrainingLocations,
        });
    };

    return (
        <SettingsCardLayout rounded>
            <SwitchFormComponent
                label={
                    <TrainingProgramTitle>
                        {t('settings.training-programs.applicable-locations.title')}
                    </TrainingProgramTitle>
                }
                onChange={handleOnConfigChange}
                loading={loading}
                enabled={config.enableApplicableLocations}
            />
            <TrainingProgramTrainerBody>
                {t('settings.training-programs.applicable-locations.subtitle')}
            </TrainingProgramTrainerBody>
        </SettingsCardLayout>
    );
};
